module.exports = __webpack_public_path__ + "img/mobile-monitor.3d0136d2.svg";